import type { ReportDialogStep } from '@/reporting/util';
import type { WiwState } from '@/store';

export const getReportActiveDialog = (state: WiwState): ReportDialogStep | undefined =>
  state.reporting.customReportBuilder.activeDialog;
